import "./WhyDTFSection.css";
import VideoSection from "../video-section/VideoSection";

const WhyDTFSection = ({ data }: { data: any }) => {
  return (
    <section id="why-dtf" className="why-dtf-section">
      
      {/* <div className="why-dtf-content">
        <div className="why-dtf-text gap-4">
        <div className="why-dtf-title">WHY WE MUST ?</div>
 <div className="why-wemust-points">
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1765988963214_QUALITY_RED.png"
    width="36" height="36" alt="Retail-Level Quality" />
    <div>
      <div className="title">
        Retail-Level Quality
      </div>
      <div className="description">
        Specialty prints and transfers engineered for premium apparel brands
      </div>
    </div>
  </div>
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1765988936616_FAST_RED.png"
    width="36" height="36" alt="Fastest Turnaround" />
    <div>
      <div className="title">
        Fastest Turnaround
      </div>
      <div className="description">
        24–48 hour production with free expedited shipping on orders above $250
      </div>
    </div>
  </div>
  
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1765988950114_NO_MINIMUMS_RED.png"
    width="36" height="36" alt="No Minimums" />
    <div>
      <div className="title">
        No Minimums
      </div>
      <div className="description">
        No minimum order quantity required
      </div>
    </div>
  </div>
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1766068464370_Scale.png"
    width="36" height="36" alt="Scale & Reliability" />
    <div>
      <div className="title">
      Scale & Reliability
     
      </div>
      <div className="description">
       70,000 sq. ft. and 60+ printers across Canada and the U.S.
      </div>
    </div>
  </div>
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1766068498141_PANTONE.png"
    width="36" height="36" alt="Pantone Accuracy" />
    <div>
      <div className="title">
      Pantone Accuracy
      
      </div>
      <div className="description">
      Pantone matching available for DTF transfers
      </div>
    </div>
  </div>
  <div className="why-wemust-point-item">
    <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1765988928570_CUSTOMER_SERVICE_RED.png"
    width="36" height="36" alt="Customer-First Service" />
    <div>
      <div className="title">
        Customer-First Service
      </div>
      <div className="description">
        Dedicated customer service available
      </div>
    </div>
  </div>
</div>
        </div>
        <div className="why-dtf-image">
          <img src={data?.contentBlock?.image} alt="DTF Printing" />
        </div>
      </div> */}

      {/* The WeMust Transfers DTF Process Section */}
      <section className="dtf-process-section max-w-screen-xl mx-auto py-16 px-4">
        <div className="dtf-process-header text-center mb-12">
          <h2 className="dtf-process-title text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            The WeMust Transfers DTF Process
          </h2>
          <p className="dtf-process-description text-base text-gray-600 max-w-3xl mx-auto">
          We Must DTF transfers are designed to make production easier—fast turnaround, reliable quality, and press-ready results you can count on. Upload your design, place your order, and keep your workflow moving.
          </p>
        </div>

        {/* Process Cards with Connecting Line */}
        <div className="dtf-process-cards-container relative">
          {/* Connecting Line */}
          <div className="dtf-process-line absolute top-1/2 left-0 right-0 h-0 border-t-2 border-dashed border-[#861528] transform -translate-y-1/2 z-0 hidden md:block">
            {/* Nodes/Dots */}
            <div className="absolute left-[10%] top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-3 h-3 bg-[#861528] rounded-full"></div>
            <div className="absolute left-[50%] top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-3 h-3 bg-[#861528] rounded-full"></div>
            <div className="absolute right-[10%] top-1/2 transform -translate-y-1/2 translate-x-1/2 w-3 h-3 bg-[#861528] rounded-full"></div>
          </div>

          {/* Process Cards */}
          <div className="dtf-process-cards grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative z-10">
            {/* Card 1 */}
            <div className="dtf-process-card bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
              <div className="dtf-process-card-image bg-gray-100 h-64  items-center justify-center rounded-t-xl">
                <div className="text-gray-400 text-sm">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770122560489_Upload.jpg" alt="Upload Design" style={{width: '100%', height: '250px'}}/></div>
              </div>
              <div className="dtf-process-card-content p-6">
                <h3 className="dtf-process-card-title text-lg md:text-xl font-semibold text-gray-900 mb-2">
                  Upload Design
                </h3>
                <p className="dtf-process-card-description text-sm md:text-base text-gray-600 leading-relaxed">
                Upload your artwork directly to our platform. We check it for print accuracy and get it ready for production.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="dtf-process-card bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
              <div className="dtf-process-card-image bg-gray-100 h-64 items-center justify-center rounded-t-xl">
                <div className="text-gray-400 text-sm">
                  <img
                    src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770122253099_24-48_hours.jpg"
                    alt="24–48 Hour Print & Ship"
                    style={{ width: "100%", height: "250px" }}
                  />
                </div>
              </div>
              <div className="dtf-process-card-content p-6">
                <h3 className="dtf-process-card-title text-lg md:text-xl font-semibold text-gray-900 mb-2">
                  24–48 Hour Print & Ship
                </h3>
                <p className="dtf-process-card-description text-sm md:text-base text-gray-600 leading-relaxed">
                Your transfers are printed in-house with precision and shipped fast—typically within 24–48 hours.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="dtf-process-card bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
              <div className="dtf-process-card-image bg-gray-100 h-64 items-center justify-center rounded-t-xl">
                <div className="text-gray-400 text-sm">
                  <img
                    src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770122495785_Ready_to_press.jpg"
                    alt="Ready to Press"
                    style={{ width: "100%", height: "250px" }}
                  />
                </div>
              </div>
              <div className="dtf-process-card-content p-6">
                <h3 className="dtf-process-card-title text-lg md:text-xl font-semibold text-gray-900 mb-2">
                  Ready to Press
                </h3>
                <p className="dtf-process-card-description text-sm md:text-base text-gray-600 leading-relaxed">
                Transfers arrive fully cured and ready to heat-press for consistent, professional results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="video-section" key="video-section">
        <VideoSection />
      </div>
    </section>
    
    
  );
};

export default WhyDTFSection;
